import React, { useState, useMemo, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import loadable from '@loadable/component'
import {
  Box,
  Button,
  // Menu as MenuG,
  // Heading,
  DropButton as DropButtonG,
  // ResponsiveContext,
  // Drop,
  // Button,
  Text,
  Image,
} from 'grommet'
import {
  ShareOption,
  Tools,
  Code,
  Info,
  Announce,
  User,
  Logout,
  Video,
  Menu,
  Star,
  Sun,
  Moon,
  SettingsOption,
} from 'grommet-icons'
import styled from 'styled-components'
import { setLightness } from 'polished'
import withLocation from '../HOC/withLocation'
import LogoImage from '../../images/Picker-Wheel-Logo-Small.png'
import MoreButton from '../Button/MoreButton'
import MenuIcon from '../MenuIcon'
// import BMCIcon from '../images/common/bmc-new-btn-logo.png'
// import AuthButton from './Auth/HeaderAuthButton'
// import AuthModal from '../Auth/AuthModal'
import { openAuthModal, signOutFirebase } from '../../redux/auth/actions'
// import PersonIcon from '../images/icons/icon-person.png'
import { StaticImage } from 'gatsby-plugin-image'
import SpinnerFullScreen from '../Spinner/SpinnerFullScreen'
// import DarkModeButton from './Button/DarkModeButton'
import TipDrop from '../Button/TipDrop'
import { useDarkMode } from '../../contextHook/darkMode'
// import Moon from '../../icon/moon'
// import Sun from '../../icon/sun'
// import NewWrapper from '../NewWrapper'
import { useIsPremium } from '../../hook/useIsPremium'
// import TeamPWIcon from '../../images/tools/Team-PW.png'
// import NumberPWIcon from '../../images/tools/Number-PW.png'
// import YesNoPWIcon from '../../images/tools/Yes-No-PW.png'
// import LetterPWIcon from '../../images/tools/Letter-PW.png'
// import ImagePWIcon from '../../images/tools/Image-PW.png'
// import CountryPWIcon from '../../images/tools/Country-PW.png'
// import DatePWIcon from '../../images/tools/Date-PW.png'
// import ColorPWIcon from '../../images/tools/Color-PW.png'
// import NFLPWIcon from '../../images/tools/NFL-PW.png'
// import NBAPWIcon from '../../images/tools/NBA-PW.png'
// import MLBPWIcon from '../../images/tools/MLB-PW.png'
// import StatePWIcon from '../../images/tools/State-PW.png'
// import PWIcon from '../../images/Picker-Wheel-Logo-Small.png'
// import IGCommentPWIcon from '../../images/tools/Instagram-Comment-PW.png'
import LoadSaveButton from '../Button/LoadSaveButton'
import { setToolSettingsActiveIndex } from '../../redux/common/actions'
import NewWheelButton from '../Button/NewWheelButton'
import NewWheelDrop from '../Modals/NewWheelDrop'
import { useWindowSize } from '../../hook/useWindowSize'
import MegaMenuTools from './megaMenuTools'

// import { useHideInput } from '../contextHook/hideInput'

const ShareBox = loadable(() => import('../ShareWheel'), {
  fallback: (
    <Box
      width="42rem"
      height="17.6rem"
      align="center"
      justify="center"
      background="baseBackground"
    >
      Loading...
    </Box>
  ),
})
const AuthModal = loadable(() => import('../Auth/AuthModal'), {
  fallback: <SpinnerFullScreen caption="Please wait..." />,
})

const DropButton = styled(DropButtonG)`
  @media (max-width: 900px) {
    & > div > span {
      display: none;
    }
    & > div > div {
      display: none;
    }
  }
`

const LinkAHome = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.global.colors.text};
  &:focus-visible {
    background: ${props => props.theme.global.colors.hoverBg};
    outline: none;
  }
`

const LinkA = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.global.colors.text};
  width: 100%;
`

const MenuBox = styled(Box)`
  /* width: 16rem; */
  /* flex-wrap: nowrap; */
  flex-shrink: 0;
  /* font-weight: 500; */
`

const NoWrapText = styled(Text)`
  white-space: pre;
  font-weight: 500;
`

// const CoffeeImageBox = styled(Box)`
//   /* height: 3rem; */
//   /* width: 12px; */
//   justify-content: center;
//   align-items: center;
//   /* margin-right: 1rem; */
// `
const ProfileImageBox = styled(Box)`
  position: relative;
  height: 2.4rem;
  width: 2.4rem;
  background-color: ${props => props.theme.global.colors.placeholder};
  border-radius: 50%;
  overflow: hidden;
`

// const CoffeeImg = styled(Image)`
//   /* margin-bottom: 0px; */
//   width: 12px;
// `

// const ImageIcon = styled.img`
//   /* margin-bottom: 0; */
//   height: 1.8rem;
//   width: 1.8rem;
// `

const LogoBox = styled(Box)`
  margin-left: 3.5rem;
  @media (max-width: 900px) {
    margin-left: 1.5rem;
  }
`

const RightMenuBox = styled(Box)`
  margin-right: 2.8rem;
  @media (max-width: 900px) {
    margin-right: 0rem;
  }
`

// const LogoIconBox = styled(Box)`
//   height: 3.6rem;
//   width: 3.6rem;
//   @media (max-width: 900px) {
//     height: 3.2rem;
//     width: 3.2rem;
//   }
// `

// const LogoHeading = styled(Heading)`
//   font-size: 3.2rem;
//   letter-spacing: -0.2px;
//   @media (max-width: 900px) {
//     font-size: 1.8rem;
//   }
// `

// const ShareOptionIcon = styled(ShareOption)`
//   height: 1.8rem;
//   width: 1.8rem;
//   @media (max-width: 900px) {
//     height: 1.6rem;
//     width: 1.6rem;
//   }
// `
const PWLogoImage = styled(Image)`
  height: 3.8rem;
  width: 3.8rem;
`

const ShareButtonBox = styled(Box)`
  background-color: ${props =>
    setLightness(0.85, props.theme.global.colors.primary01)};
  :hover {
    background-color: ${props =>
      setLightness(0.8, props.theme.global.colors.primary01)};
  }
`

const ToolsButtonBox = styled(Box)`
  :hover {
    background-color: ${props => props.theme.global.colors.hoverBg};
  }
  @media (max-width: 900px) {
    display: none;
  }
`

const MenuButtonBox = styled(Box)`
  :hover {
    background-color: ${props => props.theme.global.colors.hoverBg};
  }
`

const SettingsButton = styled(Button)`
  @media (max-width: 900px) {
    display: none;
  }
`

const Header = props => {
  const logoWordBlack = useMemo(
    () => (
      <StaticImage
        src="../../images/Picker-Wheel-Word-Black.png"
        width={152}
        height={38}
        placeholder="none"
        loading="eager"
        alt="pickerwheel.com"
      />
    ),
    [],
  )

  const logoWordWhite = useMemo(
    () => (
      <StaticImage
        src="../../images/Picker-Wheel-Word-White.png"
        width={152}
        height={38}
        placeholder="none"
        loading="eager"
        alt="pickerwheel.com"
      />
    ),
    [],
  )

  const [logoWord, setLogoWord] = useState('')
  const { show: authModal } = useSelector(state => state.auth.authModal)
  const { authenticated, currentUser } = useSelector(state => state.auth)
  const darkMode = useDarkMode()
  const { isPremium } = useIsPremium()
  const { websiteMode } = useSelector(state => state.common)
  const [shareOpen, setShareOpen] = useState(false)
  const [toolsOpen, setToolsOpen] = useState(false)
  const windowSize = useWindowSize()

  // const ref = useRef()
  const dispatch = useDispatch()

  const shareModeActive =
    websiteMode !== 'Normal' && websiteMode !== 'ShareEditingMode'
  const shareEditingActive = websiteMode === 'ShareEditingMode'

  useEffect(() => {
    if (darkMode.value) {
      setLogoWord(logoWordWhite)
    } else {
      setLogoWord(logoWordBlack)
    }
  }, [darkMode.value])

  useEffect(() => {
    const login = props.search.login
    if (login === 'needed') {
      dispatch(openAuthModal(true))
      window.history.replaceState({}, '', '/')
    }
  }, [])

  const pageName = props.urlLocation.pathname
  const isTool =
    (pageName.includes('tools') && pageName.length > 10) || pageName === '/'

  // const toolsMenu = [
  //   {
  //     href: '/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={PWIcon} alt="Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-team-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={TeamPWIcon} alt="Team Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Team Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/yes-or-no-wheel/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={YesNoPWIcon} alt="Yes No Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Yes No Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-number-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={NumberPWIcon} alt="Number Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Number Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-letter-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={LetterPWIcon} alt="Letter Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Letter Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-country-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={CountryPWIcon} alt="Country Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Country Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-date-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={DatePWIcon} alt="Date Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Date Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-image-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={ImagePWIcon} alt="Image Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Image Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-color-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={ColorPWIcon} alt="Color Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>Color Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-nfl-team-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={
  //             <Image
  //               src={NFLPWIcon}
  //               alt="NFL Picker Wheel Icon"
  //               height="22px"
  //             />
  //           }
  //         />
  //         <NoWrapText>NFL Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-nba-team-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={
  //             <Image
  //               src={NBAPWIcon}
  //               alt="NBA Picker Wheel Icon"
  //               height="22px"
  //             />
  //           }
  //         />
  //         <NoWrapText>NBA Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-mlb-team-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={
  //             <Image
  //               src={MLBPWIcon}
  //               alt="MLB Picker Wheel Icon"
  //               height="22px"
  //             />
  //           }
  //         />
  //         <NoWrapText>MLB Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/random-state-generator/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={<Image src={StatePWIcon} alt="State Picker Wheel Icon" />}
  //         />
  //         <NoWrapText>State Picker Wheel</NoWrapText>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/instagram-comment-picker/',
  //     label: (
  //       <MenuBox direction="row">
  //         <MenuIcon
  //           size="22px"
  //           icon={
  //             <Image
  //               src={IGCommentPWIcon}
  //               alt="Instagram Comment Picker Wheel Icon"
  //             />
  //           }
  //         />
  //         <Box>
  //           <NoWrapText style={{ marginTop: '-3px', lineHeight: '1.2' }}>
  //             Instagram Comment
  //           </NoWrapText>
  //           <NoWrapText style={{ marginBottom: '-3px', lineHeight: '1.2' }}>
  //             Picker Wheel
  //           </NoWrapText>
  //         </Box>
  //       </MenuBox>
  //     ),
  //   },
  //   {
  //     href: '/tools/',
  //     label: <NoWrapText>All Tools</NoWrapText>,
  //   },
  // ]

  const preMenuItems = [
    {
      href: '/feedback/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Info color="secondary" size="small" />} />
          <NoWrapText>Feedback Us</NoWrapText>
        </MenuBox>
      ),
    },
    {
      href: '/embed-tutorial/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Code color="secondary" size="small" />} />
          <NoWrapText>Embed Wheel</NoWrapText>
        </MenuBox>
      ),
    },
    {
      href: '/changelog/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Announce color="secondary" size="small" />} />
          <NoWrapText>Latest Updates</NoWrapText>
        </MenuBox>
      ),
    },
    {
      href: '/video-gallery/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Video color="secondary" size="small" />} />
          <NoWrapText>Video Gallery</NoWrapText>
        </MenuBox>
      ),
    },
    {
      label: (
        <MenuBox direction="row">
          <MenuIcon
            icon={
              darkMode.value ? (
                // <Sun color="secondary" size="18px" />
                // <Box
                //   width="1.8rem"
                //   height="1.8rem"
                //   align="center"
                //   justify="center"
                // >
                <Sun color="secondary" size="small" />
              ) : (
                // </Box>
                // <Moon color="primary" size="18px" />
                // <Box
                //   width="1.8rem"
                //   height="1.8rem"
                //   align="center"
                //   justify="center"
                // >
                <Moon color="iconDark" size="small" />
                // </Box>
              )
            }
          />
          <NoWrapText>
            {darkMode.value ? 'Switch Light Mode' : 'Switch Dark Mode'}
          </NoWrapText>
        </MenuBox>
      ),
      onClick: darkMode.toggle,
    },
    // {
    //   label: (
    //     <LinkA href="https://www.instagram.com/pickerwheel/" target="_blank">
    //       <MenuBox direction="row">
    //         <MenuIcon icon={<Instagram color="#8a3ab9" size="small" />} />
    //         <NoWrapText>Instagram</NoWrapText>
    //       </MenuBox>
    //     </LinkA>
    //   ),
    // },
    // {
    //   label: (
    //     <LinkA href="/buyusacoffee/">
    //       <MenuBox direction="row">
    //         <CoffeeImageBox margin={{ right: '15px', left: '6px' }}>
    //           <StaticImage
    //             src="../images/common/bmc-new-btn-logo.png"
    //             alt="Buy Us A Coffee"
    //             width={12}
    //             height={18}
    //             placeholder="blurred"
    //           />
    //         </CoffeeImageBox>
    //         <NoWrapText>Buy Us A Coffee</NoWrapText>
    //       </MenuBox>
    //     </LinkA>
    //   ),
    // },
    // {
    //   label: (
    //     <MenuBox direction="row">
    //       <CoffeeImageBox margin={{ right: '15px', left: '6px' }}>
    //         <StaticImage
    //           src="../images/common/bmc-new-btn-logo.png"
    //           alt="Buy Us A Coffee"
    //           width={12}
    //           height={18}
    //           placeholder="blurred"
    //         />
    //       </CoffeeImageBox>
    //       <NoWrapText>Buy Us A Coffee</NoWrapText>
    //     </MenuBox>
    //   ),
    //   onClick: () => {
    //     if (typeof window !== 'undefined') {
    //       const win = window.open(
    //         'https://www.buymeacoffee.com/SDCGFbE5A',
    //         '_blank',
    //       )
    //       if (win != null) {
    //         win.focus()
    //       }
    //     }
    //   },
    // },
  ]
  if (windowSize.width <= 900) {
    preMenuItems.unshift({
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<SettingsOption color="secondary" size="small" />} />
          <NoWrapText>Settings</NoWrapText>
        </MenuBox>
      ),
      onClick: () => {
        const element = document.getElementById('ToolSettingsSection')
        if (element) {
          // 👇 Will scroll smoothly to the top of the next section
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' })
            // setTimeout(() => {
            dispatch(setToolSettingsActiveIndex(0))
          }, 50)

          // }, 300)
        }
      },
    })
    preMenuItems.unshift({
      href: '/tools/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Tools color="secondary" size="small" />} />
          <NoWrapText>Tools</NoWrapText>
        </MenuBox>
      ),
    })
  }
  if (!isPremium) {
    preMenuItems.unshift({
      href: '/plan/',
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Star color="secondary" size="small" />} />
          <NoWrapText>Go Premium</NoWrapText>
        </MenuBox>
      ),
    })
  }
  const profileImage =
    currentUser !== null && currentUser.photoURL ? (
      <Image src={currentUser.photoURL} alt="profile" />
    ) : (
      <StaticImage
        src="../../images/icons/icon-person.png"
        alt="account icon"
        width={18}
        height={18}
      />
    )

  const signedInMenu = [
    {
      href: '/account/',
      label: (
        <MenuBox direction="row" gap=".9rem">
          <ProfileImageBox align="center" justify="center">
            {profileImage}
          </ProfileImageBox>
          <NoWrapText>Account Info</NoWrapText>
        </MenuBox>
      ),
      // onClick: () => {
      //   navigate('/account/')
      // },
    },

    ...preMenuItems,
    {
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<Logout color="greyIcon" size="small" />} />
          <NoWrapText>Logout</NoWrapText>
        </MenuBox>
      ),
      onClick: () => {
        signOutFirebase()
      },
    },
  ]

  const signedOutMenu = [
    {
      label: (
        <MenuBox direction="row">
          <MenuIcon icon={<User color="secondary" size="small" />} />
          <NoWrapText>Login / Signup</NoWrapText>
        </MenuBox>
      ),
      onClick: () => {
        dispatch(openAuthModal(true))
      },
    },
    ...preMenuItems,
  ]

  let currentPage = ''
  if (pageName === '/') {
    currentPage = 'main'
  } else if (pageName.includes('random-team-generator')) {
    currentPage = 'rtg'
  } else if (pageName.includes('yes-or-no-wheel')) {
    currentPage = 'ynw'
  } else if (pageName.includes('random-number-generator')) {
    currentPage = 'rng'
  } else if (pageName.includes('random-letter-generator')) {
    currentPage = 'rlg'
  } else if (pageName.includes('random-image-generator')) {
    currentPage = 'rig'
  } else if (pageName.includes('random-country-generator')) {
    currentPage = 'rcg'
  } else if (pageName.includes('random-date-generator')) {
    currentPage = 'rdg'
  } else if (pageName.includes('instagram-comment-picker')) {
    currentPage = 'icp'
  } else if (pageName.includes('random-color-generator')) {
    currentPage = 'rcw'
  } else if (pageName.includes('random-nfl-team-generator')) {
    currentPage = 'nfl'
  } else if (pageName.includes('random-nba-team-generator')) {
    currentPage = 'nba'
  } else if (pageName.includes('random-state-generator')) {
    currentPage = 'rsg'
  } else if (pageName.includes('random-mlb-team-generator')) {
    currentPage = 'mlb'
  }

  const pageHasFile =
    currentPage === 'main' ||
    currentPage === 'rtg' ||
    currentPage === 'rig' ||
    currentPage === 'rng'

  // const isRTG = currentPage === 'rtg'

  const onShareOpen = useCallback(() => {
    setShareOpen(true)
  }, [])

  const onShareClose = useCallback(() => {
    setShareOpen(false)
  }, [])

  const onToolsOpen = useCallback(() => {
    setToolsOpen(true)
  }, [])

  const onToolsClose = useCallback(() => {
    setToolsOpen(false)
  }, [])

  return (
    <>
      {isTool && <NewWheelDrop page={currentPage} />}
      <Box
        alignSelf="stretch"
        // width="120rem"
        direction="row"
        // border={{
        //   color: "line",
        //   size: ".2rem",
        //   style: "solid",
        //   side: "bottom",
        // }}
        elevation="xsmall"
        // pad={{ vertical: '1rem' }}
        justify="center"
        flex={false}
      >
        {authModal && <AuthModal />}
        <Box direction="row" justify="between" width="100%" align="center">
          {/* {size === "medium" ? null : <Box basis="1/3"></Box>} */}
          <LinkAHome href="/">
            <LogoBox
              height="100%"
              direction="row"
              align="center"
              // gap=".8rem"
              justify="center"
              gap="0.371rem"
              pad={{ vertical: '1rem' }}
              // basis={size === "medium" ? null : "1/3"}
            >
              {/* {logoStaticImage} */}
              <PWLogoImage src={LogoImage} alt="logo" />
              {logoWord}
            </LogoBox>
          </LinkAHome>
          {shareModeActive && (
            <TipDrop content="Share View" position="bottom">
              <Box
                margin={{ left: '.8rem', right: 'auto' }}
                background="#916606"
                round="2rem"
                pad=".3rem .5rem"
                style={{ cursor: 'pointer' }}
              >
                <Text color="white" size="1.1rem" weight={700} wrap>
                  SHARE VIEW
                </Text>
              </Box>
            </TipDrop>
          )}

          <RightMenuBox
            direction="row"
            // basis={size === "medium" ? null : "1/3"}
            align="stretch"
            alignSelf="stretch"
            justify="end"
            // gap=".5rem"
            // gap="1rem"
          >
            {isTool && !shareModeActive && !shareEditingActive && (
              <NewWheelButton page={currentPage} />
            )}

            {pageHasFile && !shareModeActive && !shareEditingActive && (
              <LoadSaveButton page={currentPage} />
            )}
            {isTool && !shareModeActive && (
              <SettingsButton
                alignSelf="stretch"
                icon={<SettingsOption color="iconDarkLight" size="18px" />}
                gap=".8rem"
                label="Settings"
                secondary
                onClick={() => {
                  const element = document.getElementById('ToolSettingsSection')
                  if (element) {
                    // 👇 Will scroll smoothly to the top of the next section
                    element.scrollIntoView({ behavior: 'smooth' })
                    // setTimeout(() => {
                    dispatch(setToolSettingsActiveIndex(0))
                    // }, 300)
                  }
                }}
              />
            )}
            {!shareModeActive && isTool && (
              // <TipDrop content="Share Your Wheel" position="bottom">
              <ShareButtonBox
                direction="row"
                alignSelf="stretch"
                align="stretch"
              >
                <DropButton
                  gap=".8rem"
                  style={{
                    padding: '.8rem 1.5rem',
                    fontWeight: 500,
                    color: 'var(--blackText)',
                  }}
                  alignSelf="stretch"
                  icon={<ShareOption color="iconDark" size="18px" />}
                  dropAlign={{ top: 'bottom', right: 'right' }}
                  dropProps={{ stretch: false }}
                  open={shareOpen}
                  onOpen={onShareOpen}
                  onClose={onShareClose}
                  dropContent={
                    <ShareBox
                      pageName={pageName}
                      sharePage={currentPage}
                      onShareClose={onShareClose}
                    />
                  }
                  label={<span>Share</span>}
                />
              </ShareButtonBox>
              // </TipDrop>
            )}

            <ToolsButtonBox direction="row" alignSelf="stretch" align="stretch">
              <DropButton
                gap=".8rem"
                style={{
                  padding: '.8rem 1.5rem',
                  fontWeight: 500,
                }}
                alignSelf="stretch"
                icon={<Tools color="iconDarkLight" size="18px" />}
                dropAlign={{ top: 'bottom', right: 'right' }}
                dropProps={{ stretch: false }}
                open={toolsOpen}
                onOpen={onToolsOpen}
                onClose={onToolsClose}
                dropContent={<MegaMenuTools onClose={onToolsClose} />}
                label={<span>Tools</span>}
              />
              {/* <MenuG
                items={toolsMenu}
                alignSelf="stretch"
                dropBackground="baseBackground"
                dropAlign={{ top: 'bottom', right: 'right' }}
                dropProps={{ stretch: false }}
                style={{ fontWeight: 500 }}

                // position="bottom"
                // icon={<Tools color="iconDarkLight" />}
                // content="Tools"
              >
                <Box
                  direction="row"
                  gap=".8rem"
                  height="100%"
                  align="center"
                  pad={{ horizontal: '1.5rem', vertical: '0.8rem' }}
                >
                  <Tools color="iconDarkLight" size="18px" />
                  <Text>Tools</Text>
                </Box>
              </MenuG> */}
            </ToolsButtonBox>

            <MenuButtonBox justify="center">
              <MoreButton
                menuItems={authenticated ? signedInMenu : signedOutMenu}
                position="bottom"
                icon={<Menu color="iconDarkLight" />}
                content="Menu"
                mobilePad="10px"
              />
            </MenuButtonBox>
          </RightMenuBox>
        </Box>
      </Box>
    </>
  )
  //     }}
  //   />
  // )
}

export default withLocation(Header)

// const query = graphql`
//   query {
//     logo: file(relativePath: { eq: "Picker-Wheel-Logo.png" }) {
//       childImageSharp {
//         fixed(width: 36, height: 36) {
//           ...GatsbyImageSharpFixed
//         }
//       }
//     }
//   }
// `
